import React from "react";
import { Box } from "@chakra-ui/react";
import { LuUserRound } from "react-icons/lu";
import StepLayout from "../components/StepLayout";
import { ParentEditor } from "../components/FormControls";

export default function MotherStep({ parents, setParents, formatPhone, complete, onBack, onNext }) {
  return <StepLayout step={3} headerIcon={<LuUserRound/>} iconBg="purple.50" iconColor="purple.600" title="Datos de mamá" description="Se usará como principal contacto familiar." back={onBack} next={onNext} disabled={!complete}>
    <Box maxW="520px"><ParentEditor active="madre" parents={parents} setParents={setParents} formatPhone={formatPhone}/></Box>
  </StepLayout>;
}
